import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useDailyReviewStore } from '@/stores/dailyReview'

export function DailyReviewListPage() {
  const { batches, isLoading, error, fetchBatches } = useDailyReviewStore()

  useEffect(() => {
    fetchBatches()
  }, [fetchBatches])

  return (
    <div className="p-6 max-w-5xl mx-auto space-y-4">
      <div>
        <h1 className="text-xl font-bold">Daily Review</h1>
        <p className="text-sm text-gray-500">
          Daily ka-creatives batches — review variants, write the report together, pull files for editing.
        </p>
      </div>

      {error && <div className="text-sm text-red-600">{error}</div>}
      {isLoading && (
        <div className="flex items-center gap-2 text-gray-500 text-sm">
          <Loader2 className="h-4 w-4 animate-spin" /> Loading…
        </div>
      )}

      {!isLoading && batches.length === 0 && !error && (
        <div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-sm text-gray-400">
          No batches uploaded yet. Run <code>upload_batch.py</code> from ka-creatives-skill.
        </div>
      )}

      {batches.length > 0 && (
        <div className="rounded-lg border border-gray-200 bg-white overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500 border-b text-xs">
                <th className="px-4 py-2">Batch</th>
                <th className="px-4 py-2">Date</th>
                <th className="px-4 py-2">Status</th>
                <th className="px-4 py-2">Shoots</th>
                <th className="px-4 py-2">Videos</th>
                <th className="px-4 py-2">PASS / FAIL</th>
                <th className="px-4 py-2">Reviewers</th>
              </tr>
            </thead>
            <tbody>
              {batches.map((batch) => (
                <tr key={batch.id} className="border-b last:border-0 hover:bg-gray-50">
                  <td className="px-4 py-2">
                    <Link
                      to={`/internal/daily-review/${batch.id}`}
                      className="font-medium text-blue-600 hover:underline"
                    >
                      {batch.name}
                    </Link>
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap">{batch.batch_date ?? '—'}</td>
                  <td className="px-4 py-2">
                    <span
                      className={`text-xs px-2 py-0.5 rounded ${
                        batch.status === 'ready'
                          ? 'bg-green-100 text-green-700'
                          : 'bg-amber-100 text-amber-700'
                      }`}
                    >
                      {batch.status}
                    </span>
                  </td>
                  <td className="px-4 py-2">{batch.stats.shoot_count ?? '—'}</td>
                  <td className="px-4 py-2">{batch.stats.video_count ?? '—'}</td>
                  <td className="px-4 py-2">
                    {batch.stats.pass != null ? (
                      <>
                        <span className="text-green-700">{batch.stats.pass}</span>
                        {' / '}
                        <span className="text-red-700">{batch.stats.fail}</span>
                      </>
                    ) : (
                      '—'
                    )}
                  </td>
                  <td className="px-4 py-2">{batch.reviewer_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
